export default __webpack_public_path__ + "locales/nl/People.json?hash=03c00fdd747933df83e7dffd96ddf59c";